import React, { useEffect } from 'react';
import { getMarketoFormId } from 'utils/marketo';
import LoggedInUser from 'components/Page/Toolbox/LoggedInUser';
import { saveForm, init } from 'services/marketoService';
import Button from 'components/Core/Button';
import handleNavigate from 'utils/handleNavigate';
import { WithUserContext } from 'utils/UserContext';

const LoggedInUserDownload = ({
  userInfo,
  inlineMarketingForm,
  title,
  hasTitleImage,
  buttonTitle,
  onFormSuccess = () => {},
  redirectUrl,
  redirectTarget,
}) => {
  const marketoFormId = getMarketoFormId(inlineMarketingForm.marketoForm);

  useEffect(() => {
    userInfo && init(marketoFormId);
  }, []);

  const onClick = async () => {
    const { user_id, bookmarks, isSocial, picture, question, ...userProps } = userInfo;

    const { data } = await saveForm({
      ...userProps,
      marketoFormId,
    });

    if (redirectUrl) {
      handleNavigate(redirectUrl, redirectTarget);
      return;
    }

    if (inlineMarketingForm.redirectUrl) {
      handleNavigate(inlineMarketingForm.redirectUrl);
      return;
    }

    if (data.followUpUrl) {
      handleNavigate(data.followUpUrl);
    }

    onFormSuccess();
  };

  const Footer = () => (
    <Button onClick={onClick} width="100%" type="secondary" className="mt-[10px]">
      {buttonTitle}
    </Button>
  );

  return <LoggedInUser Footer={Footer} title={title} hasTitleImage={hasTitleImage} />;
};

export default WithUserContext(LoggedInUserDownload);
